import { Component, computed, ElementRef, input } from '@angular/core';
import { KopConfigService } from '../../core/kop-config.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { KopModulesService } from '../../modules/kop-modules.service';
import { wasmVectorToArray } from '../../utils/wasmVector';
import { BaseElementComponent } from '../../keynav/base-element/base-element.component';
import { FocusManagerService } from '../../keynav/focus-manager.service';

@Component({
  selector: 'uuren-teksten',
  templateUrl: './uuren-teksten.component.html',
  styles: ``
})
export class UurenTekstenComponent extends BaseElementComponent{
  constructor(public kopConfigService: KopConfigService, public jsBridgeService: JSBridgeService,
    public kopModulesService: KopModulesService, elementRef: ElementRef<HTMLElement>, focusManager: FocusManagerService) { 
      super(elementRef,focusManager);
      this.keyProperty = "uuren-teksten";
    }

  public presentation = input<"classic" | "new">("new");

  public uurenTexts = computed(() => {
    console.log("alarmTexts");
    let tmUTs = this.kopConfigService.selectedAfd()?.afdeling().urenTellerTexts;
    let ret: Record<number, string> = [];
    if (tmUTs != undefined) {
      let keys = wasmVectorToArray(tmUTs.keys());
      keys.forEach(key => {
        let text = tmUTs.get(key);
        if (text != undefined) {
          ret[key] = text?.toString();
        }
      });
    }
    return ret;
  });

  public editVal: Record<number, string> = {};
  public range: Array<number> = [0, 1, 2, 3];

  public open() {
    for (let i of this.range) {
      this.editVal[i] = this.uurenTexts()[i] ?? "";
    }
    super.open();
  }

  public onSave() {
    this.close();
    this.kopConfigService.applyAfdUpdate(afd => {
      let wAfd = afd?.afdeling();
      if (wAfd != undefined) {
        wAfd.urenTellerTexts.clear();
        for (let [key, val] of Object.entries(this.editVal)) {
          if (val != "") {
            wAfd.urenTellerTexts.set(parseInt(key), val);
          }
        }
      }
      return afd;
    });
  }

}
